import React, { useCallback } from "react";
import { useParams } from "react-router";
import { useDiaEditor } from "../../components/DiaEditor";
import { NonIdealState } from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import * as yup from "yup";
import {
    CreateLandlordMutation,
    GetLandlordQueryResult, Subletter, UpdateLandlordMutation, UpdateLandlordMutationResult,
    useCreateLandlordMutation,
    useGetLandlordQuery, useUpdateLandlordMutation

} from "../../generated/graphql";
import LandlordForm from "./Form";

const schema = yup.object().shape({
    accounts_company: yup.string().min(1),
});



const contactRelationships = {
    'clientCompanyGroup': 'connect',
    'clientType': 'connect'
};

function blankValues(): Subletter {
    return {
        name: '',
        contact_name: '',
        telephone_1: '',
        telephone_2: '',
        company: '',
        address_1: '',
        address_2: '',
        city: '',
        postcode: '',
        email: ''
    };
}





export function LandlordEditor() {
    const params = useParams();
    const isNew = (params.id == 'new');
    const query = useGetLandlordQuery({ variables: { id: params.id ?? '' }, skip: isNew });
    const [saveMutation, saveResult] = useUpdateLandlordMutation();
    const [createMutation, createResult] = useCreateLandlordMutation();
    const save = useCallback(({ values }) => {
        return saveMutation({ variables: { input: values } });
    }, [saveMutation]);
    const create = useCallback(({ values }) => {
        return createMutation({ variables: { input: values } });
    }, [createMutation]);
    const getValue = useCallback((result: GetLandlordQueryResult) => {
        return result?.data?.subletter;
    }, []);
    const getSaveValue = useCallback((result: UpdateLandlordMutationResult) => {
        return result?.data?.updateSubletter;
    }, []);
    const getCreateRedirect = useCallback(({ data, baseUrl }) => {
        return baseUrl + (data?.data.createSubletter?.id);
    }, []);

    const data = useDiaEditor<Subletter, GetLandlordQueryResult, CreateLandlordMutation, UpdateLandlordMutation>(
        {
            save,
            saveResult,
            create,
            createResult,
            query: query,
            relationships: contactRelationships,
            baseUrl: '/database/landlords/',
            blankValues: blankValues,
            label: 'Landlords',
            permission: 'landlord',
            validationSchema: schema,
            getValue: getValue,
            getSaveValue: getSaveValue,
            getCreateRedirect: getCreateRedirect
        });

    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    if (data.form.status == 'loading') {
        return <WaitSpinner variant="panel" />;
    }
    return <>{data.confirmation}<LandlordForm waiting={data.waiting} diaForm={data.form} /></>;
}